import React from 'react';

import {
	Button, 
	Grid, 
	Typography, 
    TextField,
    Container,
    Avatar,
	FormControl,
	InputLabel,
	Select,
	Snackbar,
	Alert,
	makeStyles,
} from "@material-ui/core";
import PersonIcon from '@material-ui/icons/Person';

import axios from 'axios';

import ReactFlagsSelect from "react-flags-select";

import Header from "../Dashboard/Header";
import WorkArea from "../Register/WorkArea";
import { useAuthStore, useInstitutionStore } from "../../Stores/Stores";

const useStyles = makeStyles((theme) => ({
	appBarSpacer: theme.mixins.toolbar,
    form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(3),
	},
    paper: {
		marginTop: theme.spacing(8),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
    avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	content: {
		flexGrow: 1,
		height: "100vh",
		overflow: "auto",
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	dataGrid: {
		marginLeft: "24px",
		marginRight: "24px",
	},
	buttonIcon: {
		marginRight: "5px",
		marginLeft: "-5px",
	}
}));

function Profile() {
    const classes = useStyles();
    const authStore = useAuthStore();
    const institutionStore = useInstitutionStore();

    const userId = sessionStorage.getItem("userId");
    
    //  React state
	const [user, setUser] = React.useState();
    const [fname, setFname] = React.useState("");
    const [lname, setLname] = React.useState("");
    const [gender, setGender] = React.useState("");
    const [countryCode, setCountryCode] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [workArea, setWorkArea] = React.useState("");
    const [workAreaOther, setWorkAreaOther] = React.useState("");
    const [titleOfTheInstitution, setTitleOfTheInstitution] = React.useState("");

    const [iWorkArea, setIWorkArea] = React.useState([]);

    const [form, setForm] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const [failed, setFailed] = React.useState(false);
    const [countryCodeModal, setCountryCodeModal] = React.useState(false);

   	//	List of countries included in the dropdown menu
	const countries = ["AL","AD","AM","AT","AZ","BY","BE","BA","BG","HR","CY","CZ","DK","EE","FI","FR","GE","DE","GR","HU","IS","IE","IT","XK","LV","LI","LT","LU","MT","MD","MC","ME","NL","MK","NO","PL","PT","RO","RU","SM","RS","SK","SI","ES","SE","CH","TR","UA","GB","VA"];

	const countryCodeID = (code) => {
		let countryList = [{"countryId":"1","countryName":"Austria","countryCode":"AT"},{"countryId":"2","countryName":"the Kingdom of Belgium","countryCode":"BE"},{"countryId":"3","countryName":"Bulgaria","countryCode":"BG"},{"countryId":"4","countryName":"Cyprus","countryCode":"CY"},{"countryId":"5","countryName":"the Czech Republic","countryCode":"CZ"},{"countryId":"6","countryName":"the Kingdom of Denmark","countryCode":"DK"},{"countryId":"7","countryName":"the Republic of Estonia","countryCode":"EE"},{"countryId":"8","countryName":"Finlad","countryCode":"FI"},{"countryId":"9","countryName":"French Republic","countryCode":"FR"},{"countryId":"10","countryName":"the Hellenic Republic (Greece)","countryCode":"GR"},{"countryId":"11","countryName":"Croatia","countryCode":"HR"},{"countryId":"12","countryName":"the Republic of Ireland","countryCode":"IE"},{"countryId":"13","countryName":"the Republic of Italy","countryCode":"IT"},{"countryId":"14","countryName":"Latvia","countryCode":"LV"},{"countryId":"15","countryName":"Lithuania","countryCode":"LT"},{"countryId":"16","countryName":"the Great Duchy of Luxembourg","countryCode":"LU"},{"countryId":"17","countryName":"Hungari","countryCode":"HU"},{"countryId":"18","countryName":"Malta","countryCode":"MT"},{"countryId":"19","countryName":"The Netherlands","countryCode":"NL"},{"countryId":"20","countryName":"Federal Republic of Germany","countryCode":"DE"},{"countryId":"21","countryName":"Republic of Poland","countryCode":"PL"},{"countryId":"22","countryName":"Portugal","countryCode":"PT"},{"countryId":"23","countryName":"Romania","countryCode":"RO"},{"countryId":"24","countryName":"Slovakia","countryCode":"SK"},{"countryId":"25","countryName":"Slovenia","countryCode":"SI"},{"countryId":"26","countryName":"Spain","countryCode":"ES"},{"countryId":"27","countryName":"Sweden","countryCode":"SE"},{"countryId":"28","countryName":"Island","countryCode":"IS"},{"countryId":"29","countryName":"Norway","countryCode":"NO"},{"countryId":"30","countryName":"Switzerland","countryCode":"CH"},{"countryId":"31","countryName":"United Kingdom of the Great Britain and Northern Ireland","countryCode":"GB"},{"countryId":"32","countryName":"Belarus","countryCode":"BY"},{"countryId":"33","countryName":"Moldova","countryCode":"MD"},{"countryId":"34","countryName":"Russian Federation","countryCode":"RU"},{"countryId":"35","countryName":"Ukraine","countryCode":"UA"},{"countryId":"36","countryName":"Armenia","countryCode":"AM"},{"countryId":"37","countryName":"Azerbajd\u017ean","countryCode":"AZ"},{"countryId":"38","countryName":"Gruzija","countryCode":"GE"},{"countryId":"39","countryName":"Principality of Andorra","countryCode":"AD"},{"countryId":"40","countryName":"Liechtenstein","countryCode":"LI"},{"countryId":"41","countryName":"Monaco","countryCode":"MC"},{"countryId":"42","countryName":"San Marino","countryCode":"SM"},{"countryId":"43","countryName":"Vatikan City","countryCode":"VA"},{"countryId":"44","countryName":"the Republic of Albania","countryCode":"AL"},{"countryId":"45","countryName":"Bosnia and Herzegovina","countryCode":"BA"},{"countryId":"46","countryName":"Montenegro","countryCode":"ME"},{"countryId":"47","countryName":"Republic of Kosovo","countryCode":"XK"},{"countryId":"48","countryName":"The Republic of North Macedonia","countryCode":"MK"},{"countryId":"49","countryName":"The Republic of Srbia","countryCode":"RS"},{"countryId":"50","countryName":"Turkey","countryCode":"TR"}];
		for (let i = 0; i < countryList.length; i++)
			if (countryList[i].countryCode == code)
				return countryList[i].countryId;
	}

	const workAreaUpdate = (workArea) => {
		setWorkArea(workArea);
	}

    //  Configuration for Axios requests
    const config = {
        headers: {
            token: sessionStorage.getItem("token")
        }
    };

    //  GET /user/:id
    if (!user)
        axios.get(`https://hejde.um.si/api/user/${userId}`, config).then((res) => {
            setUser(res.data.data);
        }).catch((error) => console.log(error));
    
    //  Get work position options
    if (iWorkArea.length == 0){
        axios.get("https://hejde.um.si/api/codeList", config).then((res) => {
            setIWorkArea(res.data.data.userworkarea);
        }).catch((error) => console.log(error));}

    //  Update form values
    React.useEffect(() => {
        if (user) {
            setFname(user.firstName);
            setLname(user.lastName);
            setGender(user.genderISOIEC5218);
            setCountryCode(user.countryCode);
            setEmail(user.email);
            setWorkArea(user.userWorkSubAreaId);
            sessionStorage.setItem("hejde_profile_workarea", user.userWorkSubAreaId);
            setWorkAreaOther(user.workAreaOther);
            setTitleOfTheInstitution(user.titleOfTheInstitution);
        }
    }, [user]);

    //  /PUT user
    //  Update user's information
    const update = async () => {
        if (countryCode) {
            if (userId && fname && lname && gender && email && titleOfTheInstitution) {
                if (workArea != "39" || (workArea == "39" && workAreaOther)) {
                    //  Gather data
                    const user = {
                        userId: userId,
                        firstName: fname,
                        lastName: lname,
                        genderISOIEC5218: gender,
                        fk_countryList: countryCodeID(countryCode),
                        email: email,
                        password: password,
                        fk_userWorkSubArea: workArea,
                        workAreaOther: workAreaOther,
                        titleOfTheInstitution: titleOfTheInstitution
                    };
        
                    //  Update data in database
                    axios.post("https://hejde.um.si/api/user", user, config).then((res) => {
                        //  Success alert
                        setSuccess(true);
                        //  Clear sessionStorage
                        sessionStorage.removeItem("hejde_profile_workarea");
                        //  Refresh site
                        window.location.reload();
                    }).catch((error) => {
                        console.log(error);        
                        //  Failed alert
                        setFailed(true);
                    });
                } else {
                    setForm(true);                    
                }
            } else {
                setForm(true);
            }
        } else {
            setCountryCodeModal(true);
        }
    }

    return (
        <Container component="main" maxWidth="xs" style={{ marginBottom: "48px", }}>
            <Header />
            <div className={classes.paper}>
				<div className={classes.appBarSpacer} />

                <Avatar className={classes.avatar}>
                    <PersonIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Profile
                </Typography>

                <form className={classes.form}>
                    <Grid container spacing={2} style={{ marginBottom: "12px", }}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="firstName"
                                variant="outlined"
                                required
                                fullWidth
                                id="firstName"
                                label="First name"
                                autoFocus
                                value={fname}
                                onChange={(e) => setFname(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="lastName"
                                variant="outlined"
                                required
                                fullWidth
                                id="lastName"
                                label="Last name"
                                autoFocus
                                value={lname}
                                onChange={(e) => setLname(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-age-native-simple">Gender</InputLabel>
                                <Select
                                    native
                                    fullWidth
                                    required
                                    label="Gender"
                                    name="genderISOIEC5218"
                                    id="genderISOIEC5218"
                                    value={gender}
                                    onChange={(e) => setGender(e.target.value)}
                                >
                                    <option value={1}>Male</option>
                                    <option value={2}>Female</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <ReactFlagsSelect
                                id="fk_countryList"
                                countries={countries}
                                selected={countryCode}
                                onSelect={(code) => setCountryCode(code)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label="E-mail address"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Grid>
                        <Grid item md={workArea != 39 ? 12 : 6} lg={workArea != 39 ? 12 : 6} xs={workArea != 39 ? 12 : 6}>
                            <WorkArea userworkarea={iWorkArea} workAreaUpdate={workAreaUpdate} />
                        </Grid>
                        <Grid item xs={6} style={{ display: workArea != 39 ? "none" : "inherit" }}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                required={workArea == 39 ? true : false}
                                id="workAreaOther"
                                label="Work area"
                                name="workAreaOther"
                                value={workAreaOther}
                                onChange={(e) => setWorkAreaOther(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="titleOfTheInstitution"
                                label="Institution"
                                name="titleOfTheInstitution"
                                value={titleOfTheInstitution}
                                onChange={(e) => setTitleOfTheInstitution(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </form>

                <Button fullWidth variant="contained" color="primary" className={classes.submit} onClick={() => update()}>
                    Save changes
                </Button>
            </div>

            <Snackbar open={countryCodeModal} autoHideDuration={6000} onClose={() => { setCountryCodeModal(false); }}>
                <Alert onClose={() => { setCountryCodeModal(false); }} severity="error">
                    Please select a country.
                </Alert>
            </Snackbar>

            <Snackbar open={form} autoHideDuration={6000} onClose={() => { setForm(false); }}>
                <Alert onClose={() => { setForm(false); }} severity="error">
                    Please fill all required fields.
                </Alert>
            </Snackbar>

            <Snackbar open={failed} autoHideDuration={6000} onClose={() => { setFailed(false); }}>
                <Alert onClose={() => { setFailed(false); }} severity="error">
                    Something went wrong, please try again.
                </Alert>
            </Snackbar>

            <Snackbar open={success} autoHideDuration={6000} onClose={() => { setSuccess(false); }}>
                <Alert onClose={() => { setSuccess(false); }} severity="success">
                    Data successfully updated.
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default Profile;